import React from 'react'
import AddressInstructionsModal from '@components/AddressInstructionsModal'
import DeliveryWizard from '@components/DeliveryWizard'
import doesCountryRequireCookies from '@helpers/websites/doesCountryRequireCookies'
import useCountryCode from '@hooks/useCountryCode'
import {useEffect} from '@hooks/useEffect'
import {useState} from '@hooks/useState'
import useWebsiteAddressInstructionModal from '@hooks/useWebsiteAddressInstructionModal.main'
import useLayout from '@page-components/Order/useLayout'
import {useRouter} from 'next/router'

import useCartPreferences from '../hooks/useCart.main'

export default function AddressModals() {
  const preferences = useCartPreferences()
  const useAddressModal = useWebsiteAddressInstructionModal()
  const [openAddressInstructionsModal, setOpenAddressInstructionsModal] = useState<boolean>(false)
  const [openOptions, setOpenOptions] = useState(false)
  const layout = useLayout()
  const countryCode = useCountryCode()
  const needCookies = doesCountryRequireCookies(countryCode)
  const router = useRouter()
  const [shouldUse, setShouldUse] = useState<boolean>(true)

  const isNotMobileLayoutAndUseCookies = needCookies && layout !== 'mobile'

  useEffect(() => {
    if (router.query?.addressModal) {
      setShouldUse(false)
    }
  }, [router.query?.addressModal])

  useEffect(() => {
    if (
      shouldUse &&
      useAddressModal &&
      !preferences.storeId &&
      (isNotMobileLayoutAndUseCookies || !needCookies)
    ) {
      setOpenAddressInstructionsModal(true)
    }
  }, [shouldUse, useAddressModal, preferences.storeId, needCookies])

  if (!shouldUse || !useAddressModal) return null

  return (
    <>
      {openOptions ? (
        <DeliveryWizard.AsModal
          isOpen={openOptions}
          onClose={() => setOpenOptions(false)}
          actionLocation="cart"
        />
      ) : null}
      {openAddressInstructionsModal ? (
        <AddressInstructionsModal
          isOpen={openAddressInstructionsModal}
          setOpen={setOpenAddressInstructionsModal}
          setOpenAddressModal={setOpenOptions}
        />
      ) : null}
    </>
  )
}
